// extracted by mini-css-extract-plugin
module.exports = {"postMeetingWrapper":"__postMeetingWrapper___-u3mF","heading":"__heading___3RB5B","feedbackWrapper":"__feedbackWrapper___PsCSw"};